import Block from '@components/Layout/Block';
import styled from 'styled-components';
import { Props } from '../BlockMapper';
import { color, font, query } from '@design/templateFns';
import { FC } from 'react';

const ThreeColumnContent: FC<Props> = (props) => {
  const { header, contentCard } = props;
  return (
    <Block>
      <Container>
        {header && (
          <>
            <GridTopContainer>
              <ContentContainer>{header && <Header>{header}</Header>}</ContentContainer>
            </GridTopContainer>
            <Line />
          </>
        )}

        {contentCard && (
          <GridImageContainer $length={contentCard.length}>
            {contentCard.map((obj, index) => (
              <ContentContainer key={index}>
                <ImageBox> {obj.img && <img src={obj.img} />}</ImageBox>
                <ContentWrapper>
                  <Eyebrow>{obj.title}</Eyebrow>
                  <Body>{obj.description}</Body>
                </ContentWrapper>
              </ContentContainer>
            ))}
          </GridImageContainer>
        )}
      </Container>
    </Block>
  );
};

export default ThreeColumnContent;

export const Container = styled.div`
  display: grid;
  max-width: 1275px;
  margin: auto;
`;

export const Line = styled.div`
  background: linear-gradient(red, red) no-repeat center/1px 100%;
  display: block;
  height: 100px;
  margin: 50px;
`;

export const GridTopContainer = styled.div`
  display: flex;
  gap: 50px;
  flex-direction: column;
  max-width: 600px;
  margin: auto;
`;

export const GridImageContainer = styled.div<{ $length: number }>`
  display: grid;
  grid-template-columns: ${({ $length }) => ($length === 3 ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)')};
  justify-items: center;
  grid-gap: ${({ $length }) => ($length === 3 ? '60px 0' : '60px 15px')};
  @media screen and (${query.atLeast('tablet')}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const ContentWrapper = styled.div`
  text-align: center;
  max-width: 310px;

  @media screen and (${query.atLeast('tablet')}) {
    max-width: 230px;
  }
  @media screen and (${query.atLeast('desktop')}) {
    max-width: 310px;
  }
`;

export const Header = styled.h2`
  ${font('headline-md')};
  padding: 0;
`;

export const Eyebrow = styled.h3`
  ${font('subhead-md')};
  margin-top: 30px;
  @media screen and (${query.atLeast('desktop')}) {
    ${font('subhead-lg')};
  }
`;

export const Body = styled.p`
  ${font('body-sm-light')};
  color: ${color('gray4')};
  @media screen and (${query.atLeast('desktop')}) {
    ${font('body-md-light')};
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ImageBox = styled.div`
  img {
    width: 100px;
    height: 100px;
    top: 1px;
    left: 1px;
    object-fit: cover;
    object-position: center;
    border-radius: 50%;
    box-sizing: border-box;

    @media screen and (${query.atLeast('desktop')}) {
      width: 132px;
      height: 132px;
    }
  }
`;
